export { AutocompleteCellType, CELL_TYPE } from "./autocompleteType.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/autocompleteType/index.mjs
// module id = 1089
// module chunks = 1